module.exports = __webpack_public_path__ + "img/leverage-margin-model.9f58cf8a.png";